export const setProducts = (value) => {
  return {
    type: "SET_PRODUCTS",
    payload: { data: value },
  };
};
export const setProductLoading = (value) => {
  return {
    type: "SET_PRODUCT_LOADING",
    payload: { data: value },
  };
};
export const setTransferefProductsHistory = (value) => {
  return {
    type: "SET_PRODUCTS_TRANSFERED_HISTORY",
    payload: { data: value },
  };
};

export const setAvailableProducts = (value) => {
  return {
    type: "SET_AVAILABLE_PRODUCTS",
    payload: { data: value },
  };
};


export const setProductsCount = (value) => {
  return {
    type: "SET_PRODUCTS_COUNT",
    payload: { data: value },
  };
};
export const setProductsPage = (value) => {
  return {
    type: "SET_PRODUCTS_PAGE",
    payload: { data: value },
  };
};
export const setProductsLimit = (value) => {
  return {
    type: "SET_PRODUCTS_LIMIT",
    payload: { data: value },
  };
};
export const setProductHistory = (value) => {
  return {
    type: "SET_PRODUCT_HISTORY",
    payload: { data: value },
  };
};

export const setProductHistoryCount = (value) => {
  return {
    type: "SET_PRODUCT_HISTORY_COUNT",
    payload: { data: value },
  };
};
export const setProductHistoryPage = (value) => {
  return {
    type: "SET_PRODUCT_HISTORY_PAGE",
    payload: { data: value },
  };
};
export const setProductHistoryLimit = (value) => {
  return {
    type: "SET_PRODUCT_HISTORY_LIMIT",
    payload: { data: value },
  };
};
export const setProductHitoryModal = (value) => {
  return {
    type: "SET_PRODUCTS_HISTORY_MODAL",
    payload: { data: value },
  };
}
export const setProductEdit = (value) => {
  return {
    type: "SET_PRODUCTS_EDIT",
    payload: { data: value },
  };
}
export const setProduct = (value) => {
  return {
    type: "SET_PRODUCT",
    payload: { data: value },
  };
}
export const setSerchedBarcode = (value) => {
  return {
    type: "SET_SEARCHED_BARCODE",
    payload: { data: value },
  };

}
export const setSuppliers = (value) => {
  return {
    type: "SET_SUPPLIERS",
    payload: { data: value },
  };
};

export const setProductExpiryDates = (value) => {
  return {
    type: "SET_PRODUCTS_EXPIRY_DATES",
    payload: { data: value },
  };
};
export const setProductExpiryDatesCount = (value) => {
  return {
    type: "SET_PRODUCTS_EXPIRY_DATES_COUNT",
    payload: { data: value },
  };
};
export const setProductExpiryDatesLimit = (value) => {
  return {
    type: "SET_PRODUCTS_EXPIRY_DATES_LIMIT",
    payload: { data: value },
  };
};
export const setProductExpiryDatesPage = (value) => {
  return {
    type: "SET_PRODUCTS_EXPIRY_DATES_PAGE",
    payload: { data: value },
  };
};
export const setShowProductReturn = (value) => {
  console.log({value},"insideshow")
  return {
    type: "SET_SHOW_PRODUCT_RETURN",
    payload: { data: value },
  };
};
export const setCurrentProduct = (value) => {
  return {
    type: "SET_CURRENT_PRODUCT_RETURN",
    payload: { data: value },
  };
};
